import React from 'react';
import { LoginResponse } from '../models/user.model';
interface ContextProps {
    readonly userData: LoginResponse | null;
    readonly setUserData: (userData: LoginResponse) => void;
    readonly isLoggedIn: ()=>void;
}

const AppContext = React.createContext<ContextProps>({
    userData: null,
    setUserData: () => null,
    isLoggedIn: () => null,
});

export default AppContext;